import React, { useState, useEffect, useRef, Fragment } from "react";
import { useStore, useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
  Modal,
  ModalBody,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
} from "reactstrap";

// core components
import LandingNavbar from "components/Navbars/LandingNavbar.js";
import ProfilePageHeader from "components/Headers/ProfilePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import { Formik, Form, Field, ErrorMessage } from 'formik'
import {
  login,
  getUserAll,
  getUserProfile,
  deleteUser,
  approveUser,
  getUserAgenda,
  deleteAgenda,
  createAgenda
} from "../../actions";
import {
  changePassword
} from "../../actions/userAction";
import swal from "sweetalert";

import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

import * as Yup from 'yup'

const RegisterSchema = Yup.object().shape({

  password: Yup.string() //ประเภทของข้อมูลคือ String
    .min(6, 'ต้องมีอักษร 6 ตัวขึ้นไป') //ต้องมีอย่างน้อย 3 ตัวอักษรขึ้นไป
    .required('ต้องกรอกรหัสผ่าน') //ต้องกรอกช่องนี้
    .matches('^(?=.*[a-z])(?=.*[A-Z]).{6,}$', 'กรุณากรอกอย่างน้อย 6 ตัวอักษร (ภาษาอังกฤษตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่)'),
  newPassword: Yup.string() //ประเภทของข้อมูลคือ String
    .min(6, 'ต้องมีอักษร 6 ตัวขึ้นไป') //ต้องมีอย่างน้อย 3 ตัวอักษรขึ้นไป
    .required('ต้องกรอกรหัสผ่าน') //ต้องกรอกช่องนี้
    .matches('^(?=.*[a-z])(?=.*[A-Z]).{6,}$', 'กรุณากรอกอย่างน้อย 6 ตัวอักษร (ภาษาอังกฤษตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่)'),
  confirmPassword: Yup.string() //ประเภทของข้อมูลคือ String
    .min(3, 'ต้องมีอักษร 3 ตัวขึ้นไป') //ต้องมีอย่างน้อย 3 ตัวอักษรขึ้นไป
    .required('ต้องยืนยันรหัสผ่าน') //ต้องกรอกช่องนี้
    //ตรวจสอบว่า password match หรือไม่
    .test('passwords-match', 'รหัสผ่านไม่ตรงกัน', function (value) {
      return this.parent.newPassword === value;
    }),
 

});

function ChangePasswordPage() {
  useEffect(() => {
    document.body.classList.add("user-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("user-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  // useEffect(() => {
  //   document.body.classList.add("login-page");
  //   document.body.classList.add("sidebar-collapse");
  //   document.documentElement.classList.remove("nav-open");
  //   window.scrollTo(0, 0);
  //   document.body.scrollTop = 0;
  //   return function cleanup() {
  //     document.body.classList.remove("login-page");
  //     document.body.classList.remove("sidebar-collapse");
  //   };
  // }, []);

  const {
    adminGetProfile: userProfile,
    adminGetAllUser: allUser,
    adminGetUserAgenda: userAgenda,
    adminGetUserDiary: userDiary,
    adminGetUserPractice: userPractice
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [token, setToken] = useState(localStorage.getItem("access-token"));
  const [admin, setAdmin] = useState({});
  
  const yourDate = new Date()
  const current = moment(yourDate).format("YYYY-MM-DD").toString();
  
  useEffect(() => {
    setToken(localStorage.getItem("access-token"));
  });

  useEffect(() => {
    if (token) {

      dispatch(getUserProfile());
      
    }
  }, [token]);

  const _onSubmit = (data) => {

    const changePasswordModel = {
    
      Username: admin.telephone_no1,
      OldPassword: data.password,
      NewPassword: data.newPassword,
      ConfirmPassword: data.confirmPassword,
    
    }
    
    changePassword(changePasswordModel).then((res) => {
      if(res){
        swal("เปลี่ยนรหัสผ่านสำเร็จ กรุณา Login ใหม่อีกครั้ง", {
          icon: "success",
          buttons: "ตกลง และไปยังหน้า Login",
        }).then(function() {
          window.location.href = "#login-page";
         });
      }else{
        swal("รหัสผ่านเดิมไม่ถูกต้อง!", {
          icon: "warning",
          buttons: "ตกลง",
        });
      }
     
    });
  }


  const [isEdit, setIsEdit] = useState(false);
  const [isEditDiary, setIsEditDiary] = useState(false);
  const [isEditPractice,setIsEditPractice] = useState(false);
  const [isAddUserModal,setIsAddUserModal] = useState(false);
  const [userType,setUserType] = useState(false);
  const [isUpdateNoteCounsellorModal,setIsUpdateNoteCounsellorModal] = useState(false);
  const [noteCounsellorModal,setNoteCounsellorModal] = useState({});
  const [isUpdateNoteSupervisorModal,setIsUpdateNoteSupervisorModal] = useState(false);
  const [noteSupervisorModal,setNoteSupervisorModal] = useState({});
  const [isNoteSupervisorModal,setIsNoteSupervisorModal] = useState(false);
  const [selectUser, setSelectUser] = useState({});


  

  useEffect(() => {
    
    if (userProfile.data && !userProfile.isLoading && !userProfile.isFailed) {
      setAdmin(userProfile.data);
    }
  }, [userProfile]);

  useEffect(() => {
    
    if (admin) {
      if(admin.telephone_no1) dispatch(getUserAgenda(admin.telephone_no1));
    }
  }, [admin]);

  

  const _onLogout = async () => {
    await localStorage.clear();
    await setToken(localStorage.getItem("access-token"));
  };

  

  return (
    <>
      <LandingNavbar
        token={token}
        logout={() => _onLogout()}
        onPage="profile"
      />
      <div className="wrapper">
      
        <ProfilePageHeader numberOfMember={1} profile={admin} isLoadingProfile={userProfile.isLoading} />

        <div className="section">
         
          <Container>
             
          
           
            <Row>

            <Card style={{ width: "70%" }}>
              <CardBody>
                <CardTitle tag="h4" style={{ marginTop: "0px" }}>
                  เปลี่ยนรหัสผ่าน
                </CardTitle>
               



                <Formik
                    initialValues={{
                    
                      password: '',
                      newPassword: '',
                      confirmPassword: '',
                      
                    }}
                    validationSchema={RegisterSchema}
                    onSubmit={(e) => _onSubmit(e)}
                  >
                    {({ errors, touched, handleSubmit, handleReset, setFieldValue }) => (
                      <Form onSubmit={handleSubmit} onReset={handleReset}>
                           <div className="form-group">
                            <label htmlFor="userName" >
                              Username: 
                            </label>
                            <label id="userName" >
                              {admin.telephone_no1}
                            </label>
                          </div>


                          <div className="form-group">
                            <label htmlFor="password" >
                              รหัสผ่านเดิม
                                          </label>
                            <Field
                              name="password"
                              type="password"
                              className={`form-control ${touched.password ? errors.password ? 'is-invalid' : 'is-valid' : ''}`}
                              id="password"
                              placeholder="Password"
                            />
                            <ErrorMessage component="div" name="password" className="invalid-feedback" />
                          </div>
                          <div className="form-group">
                            <label htmlFor="newPassword" >
                              รหัสผ่านใหม่
                                          </label>
                            <Field
                              name="newPassword"
                              type="password"
                              className={`form-control ${touched.newPassword ? errors.newPassword ? 'is-invalid' : 'is-valid' : ''}`}
                              id="newPassword"
                              placeholder="New Password"
                            />
                            <ErrorMessage component="div" name="newPassword" className="invalid-feedback" />
                          </div>
                          <div className="form-group">
                            <label htmlFor="confirmPassword" >
                              ยืนยันรหัสผ่านใหม่
                                          </label>
                            <Field
                              name="confirmPassword"
                              type="password"
                              className={`form-control ${touched.confirmPassword ? errors.confirmPassword ? 'is-invalid' : 'is-valid' : ''}`}
                              id="confirmPassword"
                              placeholder="Enter Confirm Password"
                            />
                            <ErrorMessage component="div" name="confirmPassword" className="invalid-feedback" />
                          </div>

                          <div className="row">
                            <div className="col-md-6" style={{ textAlign: 'center' }}>
                              <Button type="submit" className="btn-round" color="info" style={{ width: '80%' }}>เปลี่ยนรหัสผ่าน</Button>
                            </div>
                            <div className="col-md-6" style={{ textAlign: 'center' }}>
                              <Button type="reset" className="btn-round" color="primary" style={{ width: '50%' }}>ล้างค่า</Button>
                            </div>
                          </div>
                      </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
            </Row>
          </Container>
        </div>
        <DefaultFooter />
      </div>
     

    
    </>
  );
}

export default ChangePasswordPage;


export const columns = [
  {
    Header: () => (
      <div />
    ),
    accessor: 'name',
    maxWidth: 300,
    Cell: row => (
      <div className='first-column'>{row.value}</div>
    )
  }
];

export const subComponent = row => {
  return (
    <div>
      abcdefg
      {row.original.types.map((type, id) => {
        return (
          <div className='subRow' key={ id }>{ type.name }</div>
        );
      })}
    </div>
  );
};